"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTwoBigSlickSlides = exports.generateThreeBigSlickSlides = exports.generateOneBigSlickSlides = exports.generateBgProductList = exports.addQuery = exports.SETTINGS = void 0;
const RESPONSIVE_RULES = [{
  breakpoint: 1260,
  settings: {
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: false
  }
}, {
  breakpoint: 1000,
  settings: {
    slidesToShow: 2,
    slidesToScroll: 2,
    infinite: false
  }
}, {
  breakpoint: 720,
  settings: {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false
  }
}];

const SETTINGS = _ref => {
  let {
    toSeeNext,
    slidesToShow,
    beforeChange
  } = _ref;
  const className = `ScrollMenu ${toSeeNext ? 'ScrollMenu--toSeeNext' : ''}`;
  const resp = {
    accessibility: true,
    arrows: false,
    className,
    slide: 'div',
    draggable: false,
    slidesToShow,
    slidesToScroll: slidesToShow,
    dots: true,
    infinite: false,
    speed: 500,
    variableWidth: false,
    beforeChange: beforeChange,
    responsive: RESPONSIVE_RULES
  };
  return resp;
};

exports.SETTINGS = SETTINGS;

const addQuery = (selector, styleStr) => {
  let css = '';
  css += `${selector} {${styleStr}}`;
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.type = 'text/css';

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  head.appendChild(style);
};

exports.addQuery = addQuery;

const generateBgProductList = (idProductList, bgImage) => {
  if (idProductList && bgImage) {
    const bgImageUrl = `url(${bgImage})`;
    addQuery(`#${idProductList}`, `background-image: ${bgImageUrl};
        background-size: cover;`);
  }
};

exports.generateBgProductList = generateBgProductList;
const mediaStart = '@media only screen and (min-width: 992px) {';
const mediaEnd = '}';

const generateOneBigSlickSlides = id => {
  addQuery(`${mediaStart} #${id} .slick-cloned`, `display:none !important; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .slick-track`, `width:100% !important;${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .slick-current`, `min-width: 100% !important; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .ProductItem`, `max-width: inherit !important; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .HoverEffectCard`, `width: inherit !important; ${mediaEnd}`);
};

exports.generateOneBigSlickSlides = generateOneBigSlickSlides;

const generateTwoBigSlickSlides = id => {
  addQuery(`${mediaStart} #${id} .slick-track`, `width: inherit !important;display:flex;justify-content:space-between; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .slick-slide`, `min-width: 48% !important; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .ProductItem`, `max-width: inherit !important; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .slick-cloned`, `display:none !important; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .HoverEffectCard`, `width: inherit !important; ${mediaEnd}`);
};

exports.generateTwoBigSlickSlides = generateTwoBigSlickSlides;

const generateThreeBigSlickSlides = id => {
  addQuery(`${mediaStart} #${id} .slick-track`, `display:flex;justify-content:space-between;${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .slick-current`, `min-width: 48% !important; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .slick-slide`, `max-width: 23% !important; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .ProductItem`, `max-width: inherit !important; ${mediaEnd}`);
  addQuery(`${mediaStart} #${id} .HoverEffectCard`, `width: inherit !important; ${mediaEnd}`);
};

exports.generateThreeBigSlickSlides = generateThreeBigSlickSlides;

//# sourceMappingURL=productListUtils.js.map